<template>
  <div v-once/>
</template>
<script>
import Jcrop from 'jcrop'

import is from '../web/plugins/helper/is'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'jcrop',
  props: {
    src: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default: () => {
        return {}
      },
    },
    rect: {
      type: Array,
      default: () => {
        return [10, 10, 100, 100]
      },
    },
  },
  data() {
    return {
      pos: null,
      jcrop: null,
    }
  },
  watch: {
    rect: {
      deep: true,
      handler: function (v) {
        if (!this.jcrop.active) {
          return false
        }

        this.jcrop.active.animate(Jcrop.Rect.from(v), 20, 'inOutCirc')
          .then(() => {
            this.jcrop.focus()
          })
      },
    },
    options: {
      deep: true,
      handler: function (o) {
        this.jcrop.setOptions(o)
      },
    },
    pos: {
      deep: true,
      handler: function (pos) {
        is.setAttribute(this.jcrop.srcEl, 'data-x', pos.x)
        is.setAttribute(this.jcrop.srcEl, 'data-y', pos.y)
        is.setAttribute(this.jcrop.srcEl, 'data-w', pos.w)
        is.setAttribute(this.jcrop.srcEl, 'data-h', pos.h)
        is.setAttribute(this.jcrop.srcEl, 'data-ow', this.jcrop.srcEl.clientWidth)
        is.setAttribute(this.jcrop.srcEl, 'data-oh', this.jcrop.srcEl.clientHeight)
        is.setAttribute(this.jcrop.srcEl, 'data-nw', this.jcrop.srcEl.naturalWidth)
        is.setAttribute(this.jcrop.srcEl, 'data-nh', this.jcrop.srcEl.naturalHeight)
      },
    },
  },
  mounted: function () {
    const img = new Image()
    img.src = this.src
    this.$el.appendChild(img)
    Jcrop.load(img).then(this.startup)
  },
  beforeDestroy: function () {
    if (this.checkVariable(this.jcrop)) {
      this.jcrop.destroy()
    }
  },
  methods: {
    startup(img) {
      const options = this.checkVariable(this.options) ? this.options : {}
      this.jcrop = Jcrop.attach(img, options)
      let rect = Jcrop.Rect.sizeOf(this.jcrop.el)
      const events = ['activate', 'update', 'change', 'remove']
      events.forEach(ev => {
        this.jcrop.listen(`crop.${ev}`, widget => this.$emit(ev, widget))
      })
      if (this.isArray(this.rect) && this.getAmountOfKeys(this.rect) > 0) {
        rect = Jcrop.Rect.from(this.rect)
      } else {
        rect = rect.scale(1, 1).center(rect.w, rect.h)
      }
      this.jcrop.newWidget(rect)
      this.jcrop.focus()
      const _this = this
      this.jcrop.listen('crop.change', function(widget, e) {
        _this.pos = widget.pos
        _this.$emit('crop-change', { pos: widget.pos, el: _this.jcrop.srcEl })
      })

      // web-only styling is applied
      if (is.mobileAndTabletcheck() !== true) {
        is.setAttribute(img, 'width', img.naturalWidth)
        is.setAttribute(img, 'height', img.naturalHeight)
      }

      return this.jcrop
    },
  },
}
</script>
<style lang="scss">
.jcrop-widget .jcrop-handle {
  display: none;
  position: absolute;
  border: 1px rgba(127, 127, 127, 0.8) solid;
  width: 10px;
  height: 10px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.8);
}
.jcrop-widget .jcrop-handle.nw {
  top: -3px;
  left: -3px;
  cursor: nwse-resize;
}
.jcrop-widget .jcrop-handle.w {
  top: 50%;
  transform: translateY(-50%);
  left: -3px;
  cursor: ew-resize;
}
.jcrop-widget .jcrop-handle.sw {
  bottom: -3px;
  left: -3px;
  cursor: nesw-resize;
}
.jcrop-widget .jcrop-handle.ne {
  top: -3px;
  right: -3px;
  cursor: nesw-resize;
}
.jcrop-widget .jcrop-handle.e {
  top: 50%;
  transform: translateY(-50%);
  right: -3px;
  cursor: ew-resize;
}
.jcrop-widget .jcrop-handle.se {
  bottom: -3px;
  right: -3px;
  cursor: nwse-resize;
}
.jcrop-widget .jcrop-handle.n {
  left: 50%;
  transform: translateX(-50%);
  top: -3px;
  cursor: ns-resize;
}
.jcrop-widget .jcrop-handle.s {
  left: 50%;
  transform: translateX(-50%);
  bottom: -3px;
  cursor: ns-resize;
}
.jcrop-widget.active .jcrop-handle {
  display: block;
}
.jcrop-widget {
  position: absolute;
  box-sizing: border-box;
  border: 1px white dashed;
  opacity: 0.7;
  background: transparent;
  transition: opacity 1s;
  padding: 0;
  margin: 0;
  cursor: move;
}
.jcrop-widget:hover {
  transition: opacity 0.8s;
  opacity: 0.8;
}
.jcrop-widget:focus {
  transition: opacity 0.5s;
  opacity: 1;
  outline-style: auto;
  outline-width: 3px;
  outline-color: rgba(0, 0, 0, 0.3);
}
.jcrop-shade {
  background: rgba(0, 0, 0, 0.5);
  transition: opacity 0.4s, background-color 0.7s;
  position: absolute;
}
.jcrop-shade.l {
  top: 0px;
  left: 0px;
  height: 100%;
}
.jcrop-shade.r {
  top: 0px;
  right: 0px;
  height: 100%;
}
.jcrop-shade.t {
  top: 0px;
}
.jcrop-shade.b {
  bottom: 0px;
}
.jcrop-stage {
  position: relative;
  width: 100%;
}
.jcrop-shade {
  z-index: 1;
}
.jcrop-image-stage {
  width: 100%!important;
  overflow: hidden;
}
.jcrop-image-stage img {
  position: absolute;
  z-index: 1;
  image-orientation: from-image;
  width: 100%!important;
  max-width: 1140px;
}
.jcrop-ux-inactive-handles .jcrop-widget .jcrop-handle {
  display: block;
}
.jcrop-widget img {
  width: 100%;
  height: auto;
}
.jcrop-ux-fade-more .jcrop-widget {
  opacity: 0.25;
}
.jcrop-ux-fade-more .jcrop-widget:hover {
  transition: opacity 0.4s;
  opacity: 0.8;
}
.jcrop-ux-fade-more .jcrop-widget:focus {
  transition: opacity 0.5s;
  opacity: 1;
  outline-style: auto;
  outline-width: 3px;
  outline-color: rgba(0, 0, 0, 0.3);
}
.jcrop-ux-fade-more .jcrop-widget {
  opacity: 0.25;
}
.jcrop-ux-fade-more .jcrop-widget:hover {
  opacity: 0.65;
}
.jcrop-ux-keep-current .jcrop-widget.active {
  opacity: 1;
  outline-style: auto;
  outline-width: 3px;
  outline-color: rgba(0, 0, 0, 0.3);
}
.jcrop-ux-no-outline .jcrop-widget {
  outline: none !important;
}
.jcrop-disable.jcrop-stage {
  opacity: .8;
}
.jcrop-disable.jcrop-stage .jcrop-widget {
  outline: none !important;
}
</style>
